module.exports = __webpack_public_path__ + "static/media/foggyMountain.68f41a97.jpg";